import globalConfig from "./globalConfig";


window.miniapp = new window.hamromini_sdkjs.MiniApp();
let isInitialized = false;

export const Miniapp = {

    initialize: async function () { 
        if(!window.miniapp) {
            throw new Error("Cannot initialize miniapp");
        }
        return await window.hamromini_sdkjs.initialize(globalConfig.miniAppId, window.miniapp);
    },

    login: async function(platform) {
        const miniAppResponse = await window.miniapp.login(platform);
        return miniAppResponse;
    },
    
    logout: function() {
        window.miniapp.logout().then(() => {
            sessionStorage.clear();
            localStorage.clear();
            window.location.reload();
        })
    },

    getAccessToken: async function () {
        if (!isInitialized) {
            await Miniapp.initialize();
        }
        isInitialized = true;
        try {
            return await window.miniapp.getAccessToken();
        } catch (e) {
            console.error(e);
            return "";
        }
    },
    
    getUserProfile: async function() {
        if(!isInitialized) {
            await Miniapp.initialize();
        }
        isInitialized = true;
        try {
            const miniAppObj =  await window.miniapp.getUserProfile();
            if(miniAppObj) {
                return miniAppObj.user_profile;
            } else {
                return { "display_name": '', "photo_url": '', "user_id": '' }
            }
        } catch (e) {
            return { "display_name": '', "photo_url": '', "id": '' }
        }
        
    },

    getIsLoggedIn() {
        const profile = localStorage.getItem("mini-app-profile");
        if(profile) {
            return true;
        }
        return false;
    },

    getIsMobileDevice() {
        return window.miniapp.platform() !== "BROWSER";
    },
    exitMiniApp() {
        window.miniapp.close();
    }
}